import { render, staticRenderFns } from "./AiAccountingPanel.vue?vue&type=template&id=64b04869&scoped=true"
import script from "./AiAccountingPanel.vue?vue&type=script&lang=js"
export * from "./AiAccountingPanel.vue?vue&type=script&lang=js"
import style0 from "./AiAccountingPanel.vue?vue&type=style&index=0&id=64b04869&prod&lang=less&scoped=true"
import style1 from "./AiAccountingPanel.vue?vue&type=style&index=1&id=64b04869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b04869",
  null
  
)

export default component.exports